import { Outlet } from 'react-router-dom';
import { SiteNav } from './SiteNav';

export function SiteShell() {
  return (
    <>
      <SiteNav />
      <Outlet />
    </>
  );
}
